import { useContext, useEffect, useState } from 'react';
import { RecentlyViewedPlaceholderCarousel } from '../../../../../components/carousels/home-base-hero-carousel/RecentlyViewedPlaceholderCarousel';
import ReturnVisitorCarousel from '../../../../../components/carousels/home-base-hero-carousel/ReturnVisitorCarousel';
import { IVehicleTile } from '../../../../../types/vehicleTile';
import useAppState from '../../../../../common/state/appState';

interface IRecentlyViewedCarouselProps {
    isVisible: boolean;
    viewedVehicleList: IVehicleTile[];
    updatedViewedTiles?: (tileToRemove: IVehicleTile) => any;
    onOpenSnackBar: (text: string) => any;
}

const RecentlyViewedCarousel = ({
    isVisible,
    viewedVehicleList,
    updatedViewedTiles,
    onOpenSnackBar,
}: IRecentlyViewedCarouselProps) => {
    const favoriteVehicles = useAppState((state) => state.favoriteVehicles);
    const setFavoriteVehicles = useAppState((state) => state.setFavoriteVehicles);

    const fbsData = useAppState((state) => state.fbsData);
    const [viewedList, setViewedList] = useState(viewedVehicleList);

    useEffect(() => {
        setViewedList(viewedVehicleList);
        setFavoriteVehicles();
    }, [viewedVehicleList, setFavoriteVehicles]);

    return viewedVehicleList.length > 0 ? (
        <ReturnVisitorCarousel
            id="kmx-viewed-carousel"
            carouselName="viewed"
            analyticsName="Recently Viewed"
            isVisible={isVisible}
            vehicleTileList={viewedList}
            favoritedStockNumberList={favoriteVehicles}
            ariaLabel="Recently Viewed Vehicles"
            updatedViewedTiles={updatedViewedTiles}
            enableRemove={true}
            fbsData={fbsData}
            onOpenSnackBar={onOpenSnackBar}
            sectionName="Viewed"
        />
    ) : (
        <RecentlyViewedPlaceholderCarousel />
    );
};

export default RecentlyViewedCarousel;
